var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 3.66675V7.33341",
    stroke: "#0B847E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 36.6667V40.3334",
    stroke: "#0B847E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 22L7.33317 22",
    stroke: "#0B847E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6665 22L40.3332 22",
    stroke: "#0B847E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 32.9998L11.6289 32.3708",
    stroke: "#004945",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3711 11.6292L33.0004 10.9998",
    stroke: "#004945",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33.0002L32.3711 32.3713",
    stroke: "#004945",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6294 11.6294L11.0001 11.0001",
    stroke: "#004945",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9865 26.8164C28.2189 29.2146 28.3351 30.4137 27.6329 30.9468C26.9308 31.4798 25.8752 30.9938 23.7641 30.0218L23.218 29.7704C22.6181 29.4941 22.3181 29.356 22.0002 29.356C21.6822 29.356 21.3823 29.4941 20.7824 29.7704L20.2362 30.0218C18.1251 30.9938 17.0696 31.4798 16.3674 30.9468C15.6652 30.4137 15.7814 29.2146 16.0138 26.8165L16.0739 26.196C16.1399 25.5145 16.173 25.1738 16.0747 24.8578C15.9765 24.5419 15.7581 24.2865 15.3213 23.7757L14.9236 23.3107C13.3865 21.5132 12.6179 20.6145 12.8861 19.752C13.0804 19.1272 13.7256 18.8211 14.9236 18.506M19.3906 15.9576C20.5517 13.8747 21.1322 12.8333 22.0002 12.8333C22.8681 12.8333 23.4487 13.8747 24.6098 15.9576L24.9102 16.4965C25.2401 17.0884 25.4051 17.3843 25.6623 17.5796C25.9195 17.7748 26.2399 17.8473 26.8806 17.9923L27.4639 18.1243C29.7186 18.6344 30.846 18.8895 31.1142 19.752C31.3077 20.3744 30.9614 21.0157 30.176 21.9999",
    stroke: "#004945",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceLogo);
export default __webpack_public_path__ + "static/media/ServiceLogo.eff78a81dcff11b11be684990360bcb7.svg";
export { ForwardRef as ReactComponent };